// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { length } from '../../../../../../../common/utils/immutableHelper';

// Selectors
import { currentBoardEditorAvatarsSelector } from './boardEditorPanelSelector';
import { currentBoardIdSelector } from '../../../../../../element/board/boardSelector';

// Actions
import { fetchBoardEditorTimes } from './boardEditorPanelActions';

// Hooks
import useBooleanRatchet from '../../../../../../utils/react/useBooleanRatchet';

// Components
import BoardEditorAvatars, { AVATAR_SPREAD_DIRECTIONS } from '../../BoardEditorAvatars';

// Constants
import { USER_AVATAR_SIZES } from '../../../../../../../common/users/userConstants';
import { TooltipAlignment } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';

// Styles
import './BoardEditorsSection.scss';

const mapStateToProps = createStructuredSelector({
    currentBoardId: currentBoardIdSelector,
    currentBoardEditors: currentBoardEditorAvatarsSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchEditorTimes: (elementId) => dispatch(fetchBoardEditorTimes(elementId, true)),
});

const BoardEditorsSection = (props) => {
    const { currentBoardEditors, currentBoardId, dispatchFetchEditorTimes, isPhoneOrMobileAppMode } = props;

    const showForm = useBooleanRatchet(length(currentBoardEditors) > 1);

    // Fetch the user viewed times on mount
    React.useEffect(() => {
        dispatchFetchEditorTimes(currentBoardId);
    }, []);

    if (!showForm) return null;

    return (
        <div className="BoardEditorsSection">
            <h2>Current editors</h2>
            <div className="board-editor-avatars-container">
                <BoardEditorAvatars
                    className="BoardEditorsSectionAvatars"
                    currentBoardId={currentBoardId}
                    users={currentBoardEditors}
                    userAvatarSize={isPhoneOrMobileAppMode ? 40 : USER_AVATAR_SIZES.REGULAR_SMALL}
                    spreadDirection={AVATAR_SPREAD_DIRECTIONS.RIGHT}
                    popupId={PopupIds.SHARE_MODAL_EDITORS}
                    popupAlignment={TooltipAlignment.START}
                    popupDistance={-32}
                    popupOffset={-5}
                />
            </div>
        </div>
    );
};

BoardEditorsSection.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    currentBoardEditors: PropTypes.array,
    currentBoardId: PropTypes.string,
    dispatchFetchEditorTimes: PropTypes.func,
    isPhoneOrMobileAppMode: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(BoardEditorsSection);
